import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { ADD_PERMISSION, EDIT_PERMISSION, GET_PERMISSION } from "./actionTypes";
import {
  addPermission,
  getPermission,
  editPermission,
} from "../../http/UAM/permission.helper";
import { allPermissions } from "./action";
import { decryptedValue } from "common/utility";

function* addPermissions({ payload: { permission, history } }) {
  try {
    const responseFromAPI = yield call(addPermission, permission);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/permission`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getPermissions({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getPermission, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allPermissions({ data }));
    } else {
      yield put(allPermissions({ data: [] }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editPermissions({ payload: { permission, history } }) {
  try {
    const responseFromAPI = yield call(editPermission, permission);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/permission`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* permissionSaga() {
  yield takeLatest(ADD_PERMISSION, addPermissions);
  yield takeLatest(GET_PERMISSION, getPermissions);
  yield takeLatest(EDIT_PERMISSION, editPermissions);
}

export default permissionSaga;
